import React, { useEffect, useState } from "react";
import Button from "../common/Button/Button";
import api from "../../services/api";
import "./Chapter.css";
import { useNavigate, useParams } from "react-router-dom";

const AddChapterMaster = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        chaptername: "",
        chapterbrief: "",
    });

    useEffect(() => {
        if (id) {
            api.get(`/chaptermaster/${id}`)
                .then((res) => {
                    setFormData({
                        chaptername: res.data.chapter_name,
                        chapterbrief: res.data.chapter_brief,
                    });
                })
                .catch((err) => console.error("Error loading chapter:", err));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "chapterimage") {
            setFormData((prev) => ({ ...prev, [name]: files[0] }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            chaptername: formData.chaptername,
            chapterbrief: formData.chapterbrief,
        }

        const apiCall = id
            ? api.put(`/chaptermaster/${id}`, payload)   // Edit mode
            : api.post(`/chaptermaster`, payload);       // Add mode

        apiCall
            .then(() => navigate("/chaptermaster"))
            .catch((error) => console.error("Error:", error));
    };


    return (
        <div className="moduleFormContainer">
            <div className="moduleFormCard">

                <h2 className="moduleFormTitle"> {id ? "Edit Chapter" : "Create Chapter"}</h2>

                <form onSubmit={handleSubmit} className="moduleForm">

                    <div className="formGrid">
                        <div className="formGroup">
                            <label>Chapter Name</label>
                            <input
                                type="text"
                                name="chaptername"
                                value={formData.chaptername}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="formGroup">
                            <label>Chapter Brief</label>
                            <textarea
                                name="chapterbrief"
                                value={formData.chapterbrief}
                                onChange={handleChange}
                                required
                                style={{ minHeight: "5px" }}
                           
                            />
                        </div>

                    </div>

                    <div className="formActions">
                        <Button type="submit" className="submitButton">{id ? "Update" : "Submit"}</Button>
                        <button type="button" className="backButton" onClick={() => navigate(-1)}>
                            Cancel
                        </button>
                    </div>

                </form>

            </div>
        </div>
    );
};

export default AddChapterMaster;
